import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Atoms/Icon/Icon';

const AccordionItem = ({ question, answer, defaultOpen = false, className = '' }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  if (!question || !answer) return null;
  return (
    <div className={`accordion-item ${className}`}>
      <button
        className="accordion-question"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span className="text-item-title">{question}</span>
        <Icon name={isOpen ? 'TbChevronUp' : 'TbChevronDown'} usage="inline" />
      </button>
      {isOpen && (
        <div className="px-md pt-sm pb-sm">
          <p className="text-body">{answer}</p>
        </div>
      )}
    </div>
  );
};

AccordionItem.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired,
  defaultOpen: PropTypes.bool,
  className: PropTypes.string,
};

export default AccordionItem;